const MAX_ATTEMPTS = 20
const RETRY_INTERVAL_MS = 100

let listenersRegistered = false

const sendUpdate = () => {
  const data = { websiteUrl: window.location.href }
  if (window.userJWT) data.jwt = window.userJWT
  window.botpress.updateUser({ data })
}

const tryUpdate = (attempts = 0) => {
  if (window.botpress) {
    sendUpdate()
    if (!listenersRegistered) {
      listenersRegistered = true
      window.botpress.on('webchat:initialized', sendUpdate)
      window.botpress.on('webchat:ready', sendUpdate)
      window.botpress.on('conversation', sendUpdate)
    }
  } else if (attempts < MAX_ATTEMPTS) {
    setTimeout(() => tryUpdate(attempts + 1), RETRY_INTERVAL_MS)
  }
}

document.addEventListener('turbo:load', () => tryUpdate())
